import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useContext, useCallback, useState, useEffect, useMemo } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { getBannerText, saveBannerText } from "@webapi/api";
import { useAuthContext } from "@authentication/context";
import { jsx as _jsx } from "react/jsx-runtime";
export var NotificationContext = /*#__PURE__*/createContext({});
export var NotificationContextProvider = function NotificationContextProvider(props) {
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showNotification = _useState2[0],
    setShowNotification = _useState2[1];
  var queryClient = useQueryClient();
  var _useQuery = useQuery(["bannerText"], getBannerText),
    notification = _useQuery.data;
  var _useMutation = useMutation(function (bannerText) {
      return saveBannerText(bannerText, authTicket);
    }, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries(["bannerText"]);
      }
    }),
    mutate = _useMutation.mutate;
  var hideNotification = useCallback(function () {
    return setShowNotification(false);
  }, [setShowNotification]);
  useEffect(function () {
    if (notification !== null && notification !== void 0 && notification.text) setShowNotification(true);else setShowNotification(false);
  }, [notification, setShowNotification]);
  return /*#__PURE__*/_jsx(NotificationContext.Provider, _objectSpread({
    value: useMemo(function () {
      return {
        notification: notification,
        hideNotification: hideNotification,
        saveNotification: mutate,
        showNotification: showNotification
      };
    }, [notification, hideNotification, showNotification, mutate])
  }, props));
};
export var useNotificationContext = function useNotificationContext() {
  return useContext(NotificationContext);
};